import React from 'react';
import { Outlet } from 'react-router-dom';
import './Projects.scss';

const Projects = () => {
    return (
        <div>
            <Outlet/>
        </div>
    );
}

export default Projects;
